// UMass Boston's undergraduate majors (#2748). Read on 2026-10-01 from the
// official Program Finder on umb.edu (its course.json feed: 249 programs, 64
// typed "Bachelor's"). The 2026-2027 Undergraduate Catalog
// (catalog.umb.edu, catoid=70) sits behind a bot challenge that blocked the
// program list, so the Program Finder is the source. Kept: every bachelor's
// program a first-year applicant can enter (62). Left out: the Accelerated
// Bachelor of Science in Nursing (for students who already hold a
// bachelor's) and Nursing RN to BS (for licensed nurses). The Program Finder
// groups programs by field, not by college, so each program's college is
// the one its own Program Finder page names (Aging Studies, Exercise &
// Health Sciences, Nursing and Urban Public Health under the Manning
// College; Early Education & Care in Inclusive Settings and Sport
// Leadership & Administration under the College of Education and Human
// Development). Names and degree abbreviations are the Program Finder's
// own. The KB's majors list was the starting point; the school's list wins.
const majors = {
    "slug": "university-of-massachusetts-boston",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UMass Boston's official Program Finder, grouped by the college or school that offers it, with the degree it leads to. Degree-completion programs for students who already hold a degree or nursing license, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Languages",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminology & Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Services",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Labor Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American & Iberian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy & Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Law & Ethics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Science and Mathematics",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Management",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems & Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Business",
                    "degree": "BS"
                },
                {
                    "name": "International Management",
                    "degree": "BS"
                },
                {
                    "name": "Management & Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Sport Business",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Robert and Donna Manning College of Nursing and Health Sciences",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Aging Studies",
                    "degree": "BA"
                },
                {
                    "name": "Exercise & Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Urban Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Early Education & Care in Inclusive Settings",
                    "degree": "BA"
                },
                {
                    "name": "Sport Leadership & Administration",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School for the Environment",
            "source": {
                "label": "UMass Boston Program Finder, Bachelor's programs",
                "url": "https://www.umb.edu/academics/program-finder/"
            },
            "majors": [
                {
                    "name": "Community Development",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies & Sustainability",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
